import LoginImage from './assets/educating-girls-symposium-logo-2021-yellow.png';
import bannerVideo from './assets/ncgs3-client-preroll-and-tutorial.mp4';
import MatchboxIcon from './assets/favicon.ico';
import MatchboxLogo from './assets/matchbox-logo-white-small.png';
import bannerImage from './assets/ncgs-banner2.jpg';

const SiteData = {
  loginTitle:
    "Welcome to the NCGS-NYSAIS Virtual Educating Girls Symposium",
  loginImagesrc: LoginImage,
  loginImagealt: 'NCGS Logo',
  attendeeTitle:'NCGS-NYSAIS Virtual Educating Girls Symposium',
  matchboxLogo: MatchboxIcon,
  matchboxIcon: MatchboxLogo,
  endOfEventPageTitle: 'NCGS-NYSAIS Virtual Educating Girls Symposium',
  matchboxLogoAlt: 'matchbox logo',
  matchboxLogoTitle: 'hello',
  attendantTitle: 'NCGS-NYSAIS Virtual Educating Girls Symposium',
  titleIndex: 'NCGS-NYSAIS Virtual Educating Girls Symposium',
  auditorium: true,
  checkRegisterList: false,
  generalChatId: 1,
  auditoriumChatIds: [54, 55],
  schemaName: 'ncgsfebsymposium',
  Isbanner: true,
  isMultipleAuditorium: true,
  bannerData: {
    backgroundURL: bannerImage,
    videoURL: bannerVideo,
  },
};
export default SiteData;
